import { observable, action, computed } from 'mobx';

import messagingService from 'services/MessagingService/MessagingService';
import {
  ONLINE_FAVORITES,
  ONLINE_FRIENDS,
  ONLINE_FRIENDS_FAVORITES,
  ONLINE_FRIENDS_FAVORITES_COUNT,
} from 'services/MessagingService/EventNames';
import UserFriendsFavoritesService from 'services/UserFriendsFavoritesService';
import UserStore from 'stores/UserStore';


class UserFriendsFavoritesStore {
  @observable friendsCount = 0;
  @observable friends = [];
  @observable favoritesCount = 0;
  @observable favorites = [];

  constructor() {
    this.messagingService = messagingService();
    this.messagingService.on(ONLINE_FRIENDS_FAVORITES, this._updateFriendsFavorites);
    this.messagingService.on(ONLINE_FRIENDS_FAVORITES_COUNT, this._updateFriendsFavoritesCount);
    this.messagingService.on(ONLINE_FRIENDS, this._updateFriends);
    this.messagingService.on(ONLINE_FAVORITES, this._updateFavorites);
  }

  searchedFriendsFavorites = (search, type) =>
    computed(() =>
      this.friendsOrFavorites(type).filter((user) => user.username.toLowerCase().includes(search.toLowerCase()))
    ).get();

  friendsOrFavorites = (type) => computed(() => {
    if (type === 'friends') {
      return this.friends;
    }

    return this.favorites;
  }).get();

  @action _updateFriendsFavorites = ([friendsResponse, favoritesResponse]) => {
    this._updateFriends(friendsResponse);
    this._updateFavorites(favoritesResponse);
  };

  @action _updateFriendsFavoritesCount = ([friendsResponse, favoritesResponse]) => {
    this.friendsCount = friendsResponse.count;
    this.favoritesCount = favoritesResponse.count;
  };

  @action _updateFriends = ({ users, count }) => {
    this.friendsCount = count;
    this.friends = users;
  };

  @action _updateFavorites = ({ users, count }) => {
    this.favoritesCount = count;
    this.favorites = users;
  };

  getOnlineFriendsOrFavourites = (type) => {
    if (type === 'friends') {
      return this.getOnlineFriends();
    } else if (type === 'favourites') {
      return this.getOnlineFavorites();
    }

    return this.getOnlineFriendsFavorites();

  };

  getOnlineFriends = () => {
    UserFriendsFavoritesService.getOnlineFriends(this._friendsFavouritesParams);
  };

  getOnlineFavorites = () => {
    UserFriendsFavoritesService.getOnlineFavorites(this._friendsFavouritesParams);
  };

  getOnlineFriendsFavorites = () => {
    UserFriendsFavoritesService.getOnlineFriendsFavorites(this._friendsFavouritesParams);
  };

  getOnlineFriendsFavoritesCounter = () => {
    UserFriendsFavoritesService.getOnlineFriendsFavoritesCount(this._friendsFavouritesParams);
  };

  @computed get _friendsFavouritesParams() {
    return {
      username: UserStore.user.username,
      accessHash: UserStore.user.accessHash,
      online: true,
      agent: 'flash',
    };
  }

  @computed get onlineFFCounter() {
    return this.friendsCount + this.favoritesCount;
  }
}

export default new UserFriendsFavoritesStore();
